<ng-container *transloco="let t">
    <mat-card class="altair-card osint-card bg-white border-radius border-none d-block"
        [class.component-dark-theme]="themeService.isDark()">
        <mat-card-content>
            <h5 class="mt-0 font-16 text-left">OSINT&nbsp;<i class="ri-information-2-fill" matTooltip="{{ t('osint-results') }}"></i>
            </h5>
            @if (osint) {
            <h5 class="text-warning">{{exposedCount | number }} {{ t("exposed-credentials") }}</h5>
            <p class="text-muted mb-0">{{emailCount | number }} {{ t("email-address-discovered") }}</p>
            <p class="text-muted mb-0">{{employeesCount | number }} {{ t("employees-found") }}</p>
            <br>
            }
            @else {
            <h5 class="text-warning">&nbsp;</h5>
            <p class="text-muted mb-0">OSINT {{ t("hasn-t-been-performed") }}</p>
            <p class="text-muted mb-0">&nbsp;</p>
            <br>
            <br>
            }
        </mat-card-content>
    </mat-card>
</ng-container>
